export default __webpack_public_path__ + "static/media/banner2.48c81556.jpg";